import React from 'react';
import TrueImpactDropdownRow from 'shared/design-system/components/TrueImpactDropdownRow';
import FeedbackDashboardFilterSelect from 'shared/components/Feedback/FeedbackDashboardFilterSelect';
import { FormGroup } from '@mui/material';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { SESEventLog } from './eventUtils';

interface MessageTypeProps {
  type: SESEventLog['eventType'] | undefined;
  className?: string;
  handleType: (type: SESEventLog['eventType'] | undefined) => unknown;
}

const TYPES: (SESEventLog['eventType'] | 'All')[] = [
  'All',
  'Send',
  'Bounce',
  'Click',
  'Delivery',
  'Open',
];

const MessageType: React.FC<MessageTypeProps> = ({
  type,
  className,
  handleType,
}) => {
  const Component = (handleClose: () => unknown) => (
    <FormGroup>
      {TYPES.map(d => {
        return (
          <TrueImpactDropdownRow
            key={d}
            selected={d === 'All' ? type === undefined : d === type}
            text={d === 'All' ? 'All Message Types' : d}
            onClick={() => {
              handleClose();
              handleType(d === 'All' ? undefined : d);
            }}
          />
        );
      })}
    </FormGroup>
  );
  return (
    <FeedbackDashboardFilterSelect
      type="radio"
      selectorLabel="Message Type"
      icon={faEnvelope}
      disableClearButton={true}
      onClearAll={undefined}
      onClose={undefined}
      Component={Component}
      className={className}
    />
  );
};

export default MessageType;
